import {
  SET_SIMPLIFIED_PRODUCTS,
} from '../actions/types';

export default (state = [], action) => {
  switch (action.type) {
    case SET_SIMPLIFIED_PRODUCTS:
      return [ ...action.payload ];
    default:
      return state;
  }
};
